export const syncCalendar = {
  title: "Sync your calendars",
  description:
    "Is your accommodation listed on several websites? Syncing your calendars helps you see your bookings and availability across all channels at once. You can import and export calendars in iCal format and keep your list of scheduled check-ins up to date.",
  accommodation: "Accommodation",
  sync: "Sync",
  addCalendar: "Add new calendar",
  confirmSync: {
    message: "Do you want to update the calendars?",
  },
  syncSuccess: {
    message: "Calendars synced successfully",
    title: "Sync successful",
  },
  calendarName: "Calendar name",
  modal: {
    header: "Add calendar",
    nameLabel: "Enter the calendar name",
    linkLabel: "Copy and paste your calendar link here",
    linkPlaceholder: "iCal link",
    cancel: "Cancel",
    save: "Save and sync",
  },
  saveSuccess: {
    message: "Success",
    title: "Calendar saved successfully",
  },
  errors: {
    validationTitle: "Validation failed",
    saveErrorTitle: "Error saving the calendar",
    unexpected: "An unexpected error occurred.",
  },
  list: {
    updated: "Updated",
    status: "Status",
    synced: "Synced",
    delete: "Delete",
    empty: "No calendars synced",
  },
  deleteConfirm: {
    title: "Do you want to delete the calendar?",
    content:
      'Deleting the calendar will also delete the bookings synced in the "Scheduled Check-ins (bookings)" menu',
  },
  deleteSuccess: {
    message: "Calendar deleted successfully",
    title: "Deleted",
  },
  deleteError: {
    message: "Error deleting the calendar",
    title: "Error",
  },
};
